export default {
  hladanyTermin: '',
  publikovany: undefined,
  autorPoslednejZmeny: undefined,
};
